import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../components/shared/page-components/LoadingPage';
import IntegrationsPage from '../../../components/subledger-integrations/IntegrationsPage';

export const Route = createFileRoute('/_authenticated/integrations/')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: IntegrationsPage,
  staticData: {
    configPageId: 'integrations',
    meta: {
      title: 'Integrations | Ledgible',
    },
  },
});
